import { Fragment, useEffect, useRef } from "react";
import { SearchBoxProvided } from "react-instantsearch-core";
import { connectSearchBox } from "react-instantsearch-dom";
import { trackOfferSearchEvent } from "../../utils/event-tracking";
import { useSearch } from "../../hooks/use-search";
import { SearchInput } from "@vinomofo/components";

type Props = SearchBoxProvided & {
  title: string;
  placeholder?: string;
};

const renderSearchBox = (props: Props) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { title, placeholder, currentRefinement } = props;
  const {
    setQuery,
    setShowSuggestions,
    updateSearch,
    query: queryState,
  } = useSearch();

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const handleChange = (query: string) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setQuery(query);
      if (query.length > 2) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }, 300);
  };

  const handleSubmit = (query: string) => {
    // console.log("SEARCHBOX TRIGGER SEARCH ===> ");
    // updateSearch(query);
    return;
  };

  return (
    <Fragment>
      <SearchInput
        title={currentRefinement ? "" : title}
        query={currentRefinement || queryState}
        placeholder={placeholder}
        onSubmit={handleSubmit}
        onChange={handleChange}
        onFocus={() => setShowSuggestions(true)}
      />
    </Fragment>
  );
};

export default connectSearchBox<Props>(renderSearchBox);
